import { root, id } from './options';

export const options = {
  ...root,
  id,
};
